import { render } from "./InformationInsert.vue?vue&type=template&id=3a4aaa71&scoped=true"
import script from "./InformationInsert.vue?vue&type=script&lang=js"
export * from "./InformationInsert.vue?vue&type=script&lang=js"

import "./InformationInsert.vue?vue&type=style&index=0&id=3a4aaa71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4aaa71"]])

export default __exports__